import React from "react";
import "./mobile-menu-icon.css";

function MobileMenuIcon() {
  return (
    <>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="17"
        height="16"
        viewBox="0 0 17 16"
      >
        <defs></defs>
        <g transform="translate(0.5)">
          <rect
            className="icon-a"
            width="16"
            height="16"
            transform="translate(0)"
          />
          <path
            className="icon-b"
            d="M1,14a1,1,0,0,1,0-2H7a1,1,0,0,1,0,2ZM1,5A1,1,0,0,1,1,3H15a1,1,0,0,1,0,2Z"
            transform="translate(0 1)"
          />
        </g>
      </svg>
    </>
  );
}

export default MobileMenuIcon;
